var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticStyle:{"width":"100%"},attrs:{"value":_vm.unsupported,"type":"warning","prominent":"","text":"","dismissible":"","transition":"scale-transition"}},[_vm._v(" "+_vm._s(_vm.$t('alerts.unsupported_browser'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }